/* eslint-disable react/jsx-props-no-spreading */
import { Button, Flex, FormControl, FormLabel, Input, Text, Image, Select } from '@chakra-ui/react';
import React from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Logo } from '../Logo/Logo';
import { useQuantitatives } from '../../contexts/QuantitativesContext';
import { CheckboxStyled } from './Login.styles';
import { LoginData, LoginSchema } from './Login.types';
import gerdauBg from '../../assets/gerdau-login-bg.webp';

export function Login() {
  const { setIsModalOpen, quantitativesData, setUserData } = useQuantitatives();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<LoginData>({
    resolver: zodResolver(LoginSchema),
  });

  const selectedProfession = watch('profissao');

  const onLogin: SubmitHandler<LoginData> = async (data) => {
    const dataProf = data.profissao === 'outro' ? data.outro : data.profissao;
    setUserData({
      nome: data.nome,
      email: data.email,
      profissao: dataProf!,
    });
    setIsModalOpen({ open: 'GeneralInfo' });
  };

  return (
    !quantitativesData && (
      <Flex flexDirection="row" justifyContent="flex-end" h="100vh" position="relative">
        <Image
          src={gerdauBg}
          alt="Gerdau Background"
          objectFit="cover"
          width="fit-content"
          height="100%"
          position="absolute"
          top="0"
          left="0"
          zIndex="-1"
        />
        <Flex
          bg="#fff"
          flexDirection="column"
          w={{ base: '100%', md: '55%', lg: '45%' }}
          h="100vh"
          justifyContent="center"
          p={{ base: '0 16px', md: '0 40px', lg: '0 80px' }}
        >
          <Logo />
          <Text fontWeight="600" fontSize="28" color="#344054" mt="50px">
            Acessar quantitativos
          </Text>
          <Text fontSize="18px" color="#718096" mt="16px">
            Insira abaixo seu nome, e-mail, selecione sua profissão e, em seguida, você será
            encaminhado para nossa ferramenta.
          </Text>
          <Flex
            as="form"
            id="loginForm"
            onSubmit={handleSubmit(onLogin)}
            flexDirection="column"
            noValidate
          >
            <FormControl mt="52px" isRequired>
              <FormLabel>Nome</FormLabel>
              <Input type="text" {...register('nome')} />
              {errors.nome && (
                <Text fontSize="12px" color="red">
                  {errors.nome.message}
                </Text>
              )}
            </FormControl>
            <FormControl mt="32px" isRequired>
              <FormLabel>E-mail</FormLabel>
              <Input type="email" {...register('email')} />
              {errors.email && (
                <Text fontSize="12px" color="red">
                  {errors.email.message}
                </Text>
              )}
            </FormControl>
            <FormControl mt="32px" isRequired>
              <FormLabel>Profissão</FormLabel>
              <Flex flexDirection={'row'} gap="16px">
                <Select
                  fontSize={'14px'}
                  width={selectedProfession === 'outro' ? 'calc(50% - 8px)' : '100%'}
                  {...register('profissao')}
                >
                  <option value="" disabled selected>
                    Escolha uma opção
                  </option>
                  <option value="arquiteto">Arquiteto</option>
                  <option value="estudante">Estudante</option>
                  <option value="engenheiro">Engenheiro</option>
                  <option value="construtor">Construtor</option>
                  <option value="outro">Outro</option>
                </Select>

                {selectedProfession === 'outro' && (
                  <FormControl width="calc(50% - 8px)">
                    <Input type="text" {...register('outro')} placeholder="Especifique" />
                  </FormControl>
                )}
              </Flex>
            </FormControl>
            {errors.profissao && (
              <Text fontSize="12px" color="red">
                {errors.profissao.message}
              </Text>
            )}
            {selectedProfession === 'outro' && errors.outro && !errors.profissao && (
              <Text fontSize="12px" color="red">
                {errors.outro.message}
              </Text>
            )}
          </Flex>
          <Flex mt="32px" gap="8px" alignItems="center">
            <CheckboxStyled
              margin="0 8px 0 0"
              alignSelf="flex-start"
              id="terms"
              {...register('terms')}
            />
            <Text color="#344054">
              Seus dados não serão compartilhados e, ao confirmar, você concorda em receber
              novidades e notícias.
              <Text as="span" color="red">
                *
              </Text>
            </Text>
          </Flex>
          {errors.terms && (
            <Text fontSize="12px" color="red">
              {errors.terms.message}
            </Text>
          )}
          <Button w="100%" bgColor="#00355D" color="#fff" mt="32px" type="submit" form="loginForm">
            Entrar
          </Button>
        </Flex>
      </Flex>
    )
  );
}
